import qs from 'querystring';

export function getQueryParameterByName(name) {
  if (typeof window !== `undefined`) {
    const query = window.location.search.substring(1);
    let value = qs.parse(query)[name];
    if (typeof value === 'undefined') {
      value = null;
    }
    return value || null;
  }
  return null;
}

// Create cookie
export function createCookie(name, value, days) {
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  } else {
    expires = '';
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
}

// Read cookie
export function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export function getUtmParams() {
  return {
    utm_campaign: getQueryParameterByName('utm_campaign'),
    utm_medium: getQueryParameterByName('utm_medium'),
    utm_source: getQueryParameterByName('utm_source'),
    utm_content: getQueryParameterByName('utm_content'),
    utm_term: getQueryParameterByName('utm_term'),
  };
}

export function getUtmfromCookies() {
  return {
    utm_campaign: readCookie('utm_campaign'),
    utm_medium: readCookie('utm_medium'),
    utm_source: readCookie('utm_source'),
    utm_content: readCookie('utm_content'),
    utm_term: readCookie('utm_term'),
  };
}

export function createUtmCookies() {
  const utmCookies = getUtmParams();
  createCookie('utm_campaign', utmCookies.utm_campaign || '');
  createCookie('utm_medium', utmCookies.utm_medium || '');
  createCookie('utm_source', utmCookies.utm_source || '');
  createCookie('utm_content', utmCookies.utm_content || '');
  createCookie('utm_term', utmCookies.utm_term || '');
}

export function clearUtmCookies() {
  createCookie('utm_campaign', '', 0);
  createCookie('utm_medium', '', 0);
  createCookie('utm_source', '', 0);
  createCookie('utm_content', '', 0);
  createCookie('utm_term', '', 0);
}



// WEBPACK FOOTER //
// ./src/utils/params.js